import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import NumberHelpers from '../helpers/NumberHelpers'
import Firestore from './Firestore'
import AlertHelpers from '../helpers/AlertHelpers'

var fs = firebase.firestore()

export default class {
    static getMyId() {
        const user = firebase.auth().currentUser
        if(user) 
            return firebase.auth().currentUser.uid
        else
            return null
    }

    static canWrite(doc, uid) {
        if(!doc || !doc.permissions || !doc.permissions.editors)
            return false

        if(!uid)
            uid = this.getMyId()

        if(!uid)
            return false

        return Boolean(doc.permissions.editors.indexOf(uid) > -1)
    }

    
} // end class

const prepareItemForStorage = function(obj) {
    let newObj = Object.assign({}, obj)
    for(let prop in newObj) {
        if(prop.substr(0,1) == '_')
            delete newObj[prop]
    }
    return newObj
}


// WEBPACK FOOTER //
// ./src/data/Security.js